//check if defined js_ajax_container

var preloader_img = 'core/assets/images/ajax_preloader_big.gif';

if(window.custom_preloader_img)
    preloader_img = window.custom_preloader_img;

(function($) {

    $.AjaxInit = function(options){

        var settings = $.extend( {
            'strContentSelector' : ".js_ajax_container",    //main css selector for jquery
            'strUrl': '',                    //request destination
            'strData': '',                    //dynamic data (serialized)
            'strExtraData': '',                //static extra data (serialized)
            'strType': 'POST',                //POST or GET
            'json': false,                    //return format true - json, false - html
            'preloader': false                //force turn on preloader
        }, options);

        if($(settings.strContentSelector).length > 0)
        {
            $($(settings.strContentSelector)).data('settings', settings);
            $.AjaxLoad({
                'objContainer': $(settings.strContentSelector),
                'strUrl':settings.strUrl,
                'strData': settings.strData,
                'strExtraData': settings.strExtraData,
                'strType': settings.strType,
                'json': settings.json,
                'preloader': settings.preloader
            });
        }
    }

    $.fn.AjaxFormHandler = function(strExtraData){

        /*var settings = $.extend( {
          'strContentSelector' : ".js_ajax_form_container",
          'strType': 'POST',
          'strData': ''
        }, options);
        */

        $(this).each(function(){

            $(this).submit(function(e) {
                if ( window.disableSubmit == false || typeof window.disableSubmit == 'undefined'){
                    e.preventDefault();
                    var formData = new FormData(this);
                    $.AjaxLoad({ 'objContainer': $(this).parents('.js_ajax_container:first'),
                        'strUrl': $(this).attr('action'),
                        //'strData': $(this).serialize(),
                        'objData' : formData,
                        'strExtraData': strExtraData,
                        'boolSubmit' : true
                    });
                }
            });

        });
    }

    $.AjaxLoad = function(options){
        if(typeof $(options.objContainer).data('settings') == 'undefined')
        {
            var settings = $.extend( {
                'objContainer' : Object(),
                'strUrl': '',
                'strData': '',
                'objData': null,
                'strExtraData': '',
                'json': false,
                'strType': 'POST',
                'preloader': false,
                'boolSubmit' : false
            }, options);
        }
        else
        {
            var objInitSettings = $(options.objContainer).data('settings');
            var settings = $.extend( {
                'objContainer' : objInitSettings.objContainer,
                'strUrl': objInitSettings.strUrl,
                'strData': objInitSettings.strData,
                'objData': objInitSettings.objData,
                'strExtraData': objInitSettings.strExtraData,
                'json': objInitSettings.json,
                'strType': objInitSettings.strType,
                'preloader': objInitSettings.preloader,
                'boolSubmit' : objInitSettings.boolSubmit
            }, options);
        }


        $(settings.objContainer).trigger('before_load');

        if (settings.preloader == true)
            $.AjaxPreloader("start", settings.objContainer, settings.json);

        if (settings.strExtraData != '' && settings.strData != '')
            settings.strExtraData = '&'+settings.strExtraData;

        if (typeof settings.objData == 'undefined') {
            var requestData = settings.strData + settings.strExtraData;
        } else {
            var requestData = settings.objData;
            $.each(
                $.QueryToObject(settings.strExtraData),
                function(k, v){
                    requestData.append(k, v);
                });
            console.log(requestData);
        }

        var objSettings = {
            url: settings.strUrl,
            type: settings.strType,
            data: requestData,
            success: function(data)
            {
                if(settings.json == false)
                {
                    $(settings.objContainer).children(":not(.ajax_preloader)").remove();
                    $(settings.objContainer).prepend(data);
                    $(settings.objContainer).find('.js_ajax_form').AjaxFormHandler(settings.strExtraData);
                }
                else
                {
                    try {
                        $(settings.objContainer).data('json', $.parseJSON(data));
                    }catch(err){ $(settings.objContainer).data('json', false); }
                }

                $(settings.objContainer).data('result', {'html': data});

                $(settings.objContainer).trigger('after_load');

                if(settings.json == false || settings.preloader == true )
                    $.AjaxPreloader("stop", settings.objContainer, settings.json);
            },
            error: function(data)
            {
                $(settings.objContainer).trigger('after_load');
                if(settings.json == false || settings.preloader == true )
                    $.AjaxPreloader("stop", settings.objContainer, settings.json);
            }
        };

        if (settings.boolSubmit) {
            objSettings.contentType = false;
            objSettings.processData = false;
        }

        var ajaxRequesr = $.ajax(objSettings);

    }


    $.AjaxPreloader = function(strAction, objContent, json){
        if( strAction == "start" )
        {
            $(objContent).find(".ajax_preloader").remove();
            $(objContent).trigger('before_preloader_show');

            var reloader_div = $('<div />', { 'class':'ajax_preloader' });
            if(window.custom_preloader_html) {
                reloader_div.append(custom_preloader_html);
            } else {
                reloader_div.append( $('<img />', { 'src': preloader_img}) );
            }

            $(objContent).append(reloader_div);
            //console.log(reloader_div.width());
            //$(reloader_div).find('img').css('margin-top', reloader_div.height() / 2 );
            $(objContent).trigger('after_preloader_show');
        }
        else if    ( strAction == "stop" )
        {
            setTimeout(function(){
                if(json == false){
                    $(document).trigger('new_content_loaded');
                }
                $(objContent).trigger('before_preloader_hide');
                $(objContent).find(".ajax_preloader").fadeOut('fast', function(){ $(this).remove(); });
                $(objContent).trigger('after_preloader_hide');
            },300);
        }

    }

    $.QueryToObject = function(query) {
        var result = {};
        query.split("&").forEach(function(part) {
            var item = part.split("=");
            result[item[0]] = decodeURIComponent(item[1]);
        });
        return result;
    }

})(jQuery);
